<template>
  <div>
    <mq-layout :mq="['mobile', 'tablet']">
      <div class="vv-progress-bar">
        <div class="meter">
          <div
            class="fill"
            :class="{ finished: fillPercentage === 100 }"
            :style="{ width: `${fillPercentage}%` }"
          />
          <span class="label" :style="{ color: fillPercentage === 100 ? 'white' : 'black' }"
            >{{ progression }}/{{ total }}</span
          >
        </div>
      </div>
    </mq-layout>

    <mq-layout mq="desktop">
      <div class="Desktop-Progress">
        <div class="Desktop-Meter" :style="styleContainer">
          <div
            class="fill"
            :class="{ finished: fillPercentage === 100 }"
            :style="{ width: `${fillPercentage}%` }"
          >
          </div>
          <span v-if="displayLabel && fillPercentage < 100" class="label" :style="{ color: fillPercentage === 100 ? 'white' : 'black' }">
            {{ progression }}/{{ total }}
          </span>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
export default {
  name: 'VvProgressBar',
  props: {
    progression: Number,
    total: Number,
    thin: {
      type: Boolean,
      required: false,
      default: false
    },
    medium: {
      type: Boolean,
      required: false,
      default: false
    },
    displayLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    fillPercentage() {
      return (this.progression / this.total) * 100
    },
    styleContainer() {
      if (this.thin) {
        return {
          height: '10px',
          'font-size': '8px'
        }
      } else if (this.medium) {
        return {
          height: '15px',
          'font-size': '12px'
        }
      } else {
        return {
          height: '20px',
          'font-size': '15px'
        }
      }
      
    },
    styleLabel() {
      return {
        color: this.fillPercentage > 0 ? 'white' : 'black',
        'margin-right': this.thin ? '4px' : '8px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-progress-bar {
  text-align: center;

  .meter {
    display: inline-block;
    width: 260px;
    height: 11px;
    position: relative;
    background: rgba(74, 74, 74, 0.08);
    border-radius: 7.5px;
  }

  .fill {
    height: 100%;
    border-radius: 7.5px;
    background-color: #d10a4a;

    &.finished {
      background-image: none;
      background-color: $secondary;
    }
  }

  .label {
    position: absolute;
    right: 4px;
    top: 0.5px;
    font-size: 7px;
    font-weight: 900;
  }
}

.Desktop-Progress {
  text-align: center;

  .Desktop-Meter {
    display: inline-block;
    width: 100%;
    position: relative;
    background: rgba(74, 74, 74, 0.08);
    border-radius: 7.5px;
  }

  .fill {
    height: 100%;
    border-radius: 7.5px;
    background-color: #d10a4a;
    text-align: right;

    &.finished {
      background-image: none;
      background-color: $secondary;
    }
  }

  .label {
    font-weight: bold;
    position: absolute;
    right: 4px;
    top: 0.5px;
    // font-size: 7px;
    font-weight: 900;
  }
}
</style>
